<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowLeft } from "@mdi/js"

export default {
  name: "ArrowLeftIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowLeft,
    }
  }
}
</script>
